module.exports = __webpack_public_path__ + "img/9788990028297.9f9f42d4.jpg";